export const Logo = ({ size = 32, light = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="16" fill={light ? "#F5EFE6" : "#28382D"} />
    <path
      d="M18 47 V33 a14 14 0 0 1 28 0 v14 h-8 v-13 a6 6 0 0 0-12 0 v13 Z"
      fill={light ? "#28382D" : "#7C9583"}
    />
    <circle cx="45.5" cy="18.5" r="4.5" fill={light ? "#7C9583" : "#F5EFE6"} />
  </svg>
);

export const Wordmark = ({ light = false }) => (
  <span
    className={`font-serif tracking-wide ${light ? "text-cream" : "text-ink"}`}
    style={{ fontSize: "1.15rem" }}
  >
    AuDHD<span className="italic">Spaces</span>
  </span>
);
